// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3Y9G7","info":"Note_info__2PAIQ","note":"Note_note__2rDYg","actions":"Note_actions__3dkCA"};